import { Space } from 'antd';
import { TripRoute } from 'components/trips/trip-route';
import { TripStatusTag } from 'components/trips/trip-status-tag';
import styles from './cargo-trips-list.module.scss';
import type { ICargoTripsListProps } from './types';

export const CargoTripsList: React.FC<ICargoTripsListProps> = (props) => {
  const { trips, onTripSelect } = props;

  return (
    <div>
      {trips.map((trip) => (
        <div key={trip.compositeId} className={styles.tripItem} onClick={() => onTripSelect(trip)}>
          <Space className={styles.compositeId}>
            <h4>{trip.compositeId}</h4>
            <TripStatusTag status={trip.status} />
          </Space>
          <div>
            <TripRoute warehousesIds={trip.relatedWarehouseIds} />
          </div>
        </div>
      ))}
    </div>
  );
};
